import { RecordData } from '../../helpers-classes';
import { DimensionData, DimensionsData, DimensionsDataIn } from './types';

export const dimensionsData = (dataIn: DimensionsDataIn = null): DimensionsData => {
	const rd = new RecordData<DimensionsDataIn>(dataIn);

	const record: DimensionsData = {
		children: rd.useNewOrDefault<Array<DimensionData>>('children', [])
	}

	return record;
};
